module.exports = __webpack_public_path__ + "img/line.3d9ac1f7.svg";